import React from "react";

const Pagination = ({ currentPage, totalPages, onPageChange }) => {
  if (totalPages <= 1) return null;

  // Gera um range de páginas para exibir
  const getPageNumbers = () => {
    const delta = 2;
    const range = [];
    for (let i = Math.max(1, currentPage - delta); i <= Math.min(totalPages, currentPage + delta); i++) {
      range.push(i);
    }
    return range;
  };

  return (
    <nav className="pagination-container" aria-label="Paginação de produtos">
      <button
        className="pagination-btn"
        onClick={() => onPageChange(currentPage - 1)}
        disabled={currentPage === 1}
        aria-label="Página anterior"
      >
        &laquo;
      </button>
      {getPageNumbers().map((page) => (
        <button
          key={page}
          className={`pagination-btn${page === currentPage ? " active" : ""}`}
          onClick={() => onPageChange(page)}
          aria-current={page === currentPage ? "page" : undefined}
        >
          {page}
        </button>
      ))}
      <button
        className="pagination-btn"
        onClick={() => onPageChange(currentPage + 1)}
        disabled={currentPage === totalPages}
        aria-label="Próxima página"
      >
        &raquo;
      </button>
      <style>{`
        .pagination-container {
          display: flex;
          gap: 0.5rem;
          justify-content: center;
          align-items: center;
          margin-top: 2rem;
        }
        .pagination-btn {
          background: #fff;
          border: 1px solid #e5e7eb;
          color: #374151;
          padding: 0.5rem 0.9rem;
          border-radius: 0.375rem;
          font-size: 1rem;
          cursor: pointer;
          transition: background 0.15s, color 0.15s, border 0.15s;
        }
        .pagination-btn.active, .pagination-btn:hover:not(:disabled) {
          background: #f43f5e;
          color: #fff;
          border-color: #f43f5e;
        }
        .pagination-btn:disabled {
          opacity: 0.5;
          cursor: not-allowed;
        }
      `}</style>
    </nav>
  );
};

export default Pagination;
